export { default } from './PrivacyPolicyItem';
